import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlatform } from '@/contexts/PlatformContext';
import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';

function iosScreenshots(language: string) {
  const suffix = language.startsWith('es') ? '_es' : '';
  return [1, 2, 3, 4].map((index) => `/pocket-agent-ios${index}${suffix}.png`);
}

function macosScreenshots() {
  return [1, 2, 3, 4, 5, 6].map((index) => `/pocket-agent-macos${index}.png`);
}

export function ScreenshotCarousel() {
  const { t } = usePlatformTranslation();
  const { i18n } = useTranslation();
  const { platform } = usePlatform();
  const screenshots = useMemo(() => {
    const base = platform === 'ios' ? iosScreenshots(i18n.language) : macosScreenshots();
    return [...base, ...base];
  }, [i18n.language, platform]);

  return (
    <div className="screenshot-carousel" aria-label={t('home.heroAlt')}>
      <div className="screenshot-carousel__viewport">
        <div className="screenshot-carousel__track">
          {screenshots.map((src, index) => (
            <img
              key={`${src}-${index}`}
              src={src}
              alt={t('home.heroAlt')}
              className="screenshot-carousel__slide"
              loading={index < 2 ? 'eager' : 'lazy'}
              decoding="async"
              draggable={false}
            />
          ))}
        </div>
      </div>
      <div className="screenshot-carousel__edge screenshot-carousel__edge--left" aria-hidden />
      <div className="screenshot-carousel__edge screenshot-carousel__edge--right" aria-hidden />
    </div>
  );
}
